import type { SituacijaExtraction, SituacijaReport } from "@/api/schemas";

/** The core declared parameters a situacija iskaz carries — mirror of
 * `_CORE_FIELDS` in permitpilot/extraction/situacija_params.py. Used only
 * as a fallback for reports persisted before the backend started sending
 * the `extraction` summary. */
const CORE_PARAM_LABELS: Array<[key: string, label: string]> = [
  ["parcela_m2", "veličina čestice"],
  ["gbp_total_m2", "GBP"],
  ["tp_m2", "tlocrtna projekcija"],
  ["kig_declared", "KIG"],
  ["kisn_declared", "KISN"],
  ["horti_declared_ratio", "hortikultura"],
  ["parking_pm", "parkirna mjesta"],
  ["mjerilo", "mjerilo"],
];

/** Normalise a report to its extraction summary, deriving one from the
 * parsed params when the backend predates the `extraction` field. */
export function situacijaExtraction(report: SituacijaReport): SituacijaExtraction {
  if (report.extraction) return report.extraction;
  const parsed: string[] = [];
  const missing: string[] = [];
  for (const [key, label] of CORE_PARAM_LABELS) {
    const v = (report.params as Record<string, unknown>)[key];
    (v != null ? parsed : missing).push(label);
  }
  return { parsed, missing, empty: parsed.length === 0, text_layer_chars: -1 };
}

/** True when the parser read no core parameter at all — the report must
 * never be presented as a successfully loaded situacija. */
export function situacijaIsEmpty(report: SituacijaReport): boolean {
  return situacijaExtraction(report).empty;
}
